import React, {useState, useEffect} from 'react'
import axios from 'axios'
import NewsListed from './NewsList'

const NewsPart = () => {

  const [articles, setArticles] =  useState([])

  useEffect (() => {
      const getArticles =  async () => {
          const response = await axios.get('https://newsapi.org/v2/everything?q=music&apiKey=0b857011d76f45199011232a5037ab67')
          console.log(response)
          setArticles(response.data.articles)
      }
      getArticles()
      },[])

  return (
    <div>
      {articles.map(articles => {
        return ( 
          <NewsListed
          title={articles.title}
          description={articles.description}
          url={articles.url}
          urlToImage={articles.urlToImage}
          />
        )
      })}
    </div>
  )
}

export default NewsPart